module.exports = __webpack_public_path__ + "img/noResult.a5fad4d3.png";